import styled from 'styled-components';

export const DefaultErrorStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background-image: url('https://s1.vcdn.biz/static/f/1040655411/bg_wallpaper-a953c70d.jpg');
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ErrorWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 25px;
  flex: 1;
  height: 100%;
`;

export const RestrictionIconWrap = styled.div`
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  border-radius: 50%;
`;

export const Icon = styled.svg`
  width: 99px;
  height: 70px;
  fill: white;
  font-size: 0;
  transition: 135ms ease-in-out;
`;
